import React from "react";
import Image from "components/Elements/Image/Image.tsx";
import { useContent } from "../../../contexts/contentContext/contentContext.js";
import config from "config.ts";

import "./BlogCard.scss";

const BlogCoverImage = `${config.api.resource}/assets/images/track-blog-cover.png`;

const BlogCard = ({ article }) => {
  const { getLanguageCulture } = useContent();

  return (
    <div className="blog-card-wrapper">
      <a
        href={`/${getLanguageCulture().substring(0, 2)}/blog/${
          article.BlogKey
        }`}
      >
        <div className="blog-card-image">
          <Image
            alt=""
            src={
              article.BlogThumbFileLocation
                ? article.BlogThumbFileLocation
                : BlogCoverImage
            }
          />
        </div>
        <div className="blog-card-text-wrapper">
          <div className="blog-title">{article.BlogArticleTitle}</div>
          <div className="blog-short-description">
            <div
              dangerouslySetInnerHTML={{
                __html: article ? article.BlogArticleShortDescription : "",
              }}
            ></div>
          </div>
        </div>
      </a>
    </div>
  );
};

export default BlogCard;
